export enum GamificationNotificationType {
    EMAIL = 'email',
    CHALLENGE = 'challenge',
}
